module.exports = __webpack_public_path__ + "static/media/cso.c7194310.png";